import React from "react";
import "./Gpmscta.css";

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const CTA = {
  title: "Make Every Port Decision Count",
  subtitle: "Transform Port Data into Operational Intelligence",
  paragraphs: [
    "Ports are becoming increasingly complex. Managing them effectively requires more than disconnected systems, traditional reports, and reactive decision-making.",
    "Global Port Management System brings together data analytics, computer vision, and predictive intelligence to help ports operate with greater visibility, efficiency, and confidence.",
    "Discover how GPMS can support smarter gate operations, improved container dwell management, and better operational decisions for your terminal.",
  ],
  brand: "Global Suntec Solutions",
  tagline: "Intelligent Technology for Smarter Port Operations.",
  primary: { label: "Request a Demo", href: "#demo" },
  secondary: { label: "Contact Our Team", href: "#contact" },
};

const GPMSCta = () => (
  <section className="gc">
    <div className="gc__container">
      <h2 className="gc__title">{CTA.title}</h2>
      <p className="gc__subtitle">{CTA.subtitle}</p>
      <span className="gc__underline" />

      {CTA.paragraphs.map((p, i) => (
        <p key={i} className="gc__text">
          {p}
        </p>
      ))}

      <div className="gc__actions">
        <a href={CTA.primary.href} className="gc__btn gc__btn--primary">
          {CTA.primary.label}
        </a>
        <a href={CTA.secondary.href} className="gc__btn gc__btn--outline">
          {CTA.secondary.label}
        </a>
      </div>

      <div className="gc__brand">
        <strong>{CTA.brand}</strong>
        <span>{CTA.tagline}</span>
      </div>
    </div>
  </section>
);

export default GPMSCta;